module.exports = __webpack_public_path__ + "to-top.svg?8673298a9af3004c516684e9213be2a2";